export default {
  mounted() {
    window.onload = () => this.preloadAppResources();
  },
  methods: {
    projectPages: () =>
      import(
        /* webpackChunkName: "projectPages" */ '@/components/sections/ProjectContentColumn.vue'
      ),
    createFontElement(className) {
      this.$nextTick(() => {
        const element = document.createElement('div');
        element.innerHTML = '.';
        element.className = `${className} hidden`;
        document.body.appendChild(element);
      });
    },
    preloadAppResources() {
      this.projectPages();
      this.createFontElement('primary-font');
    },
  },
};
